import { gql } from "graphql-tag";

export const createMatchGQL = gql`
  mutation createMatch($createMatchInput: CreateMatchInput!) {
    createMatch(createMatchInput: $createMatchInput) {
      edgeNodeId
      matchId
      gameSessionId
      moment {
        id
        appId
        snapshotId
        title
        description
        type
        scoreLabel
        scoreZoneId
        time
        data
        timesPlayed
        showTimer
        momentType
        rankOrder
        status
        createdAt
        updatedAt
        app {
          type
          title
          id
          description
          timesPlayed
          rotationMode
          category
          data
          status
          hasBattle
          createdAt
          updatedAt
        }
        zoneId
        isCompleted
      }
      players {
        user {
          id
          username
          avatar
          xp
        }
        score
      }
    }
  }
`;

export const joinFriendMatchGQL = gql`
  mutation joinFriendMatch($joinFriendMatchInput: JoinFriendMatchInput!) {
    joinFriendMatch(joinFriendMatchInput: $joinFriendMatchInput) {
      edgeNodeId
      matchId
      gameSessionId
      moment {
        id
        appId
        snapshotId
        title
        description
        type
        scoreLabel
        scoreZoneId
        time
        data
        timesPlayed
        showTimer
        momentType
        rankOrder
        status
        createdAt
        updatedAt
        app {
          type
          title
          id
          description
          timesPlayed
          rotationMode
          category
          data
          status
          hasBattle
          createdAt
          updatedAt
        }
        zoneId
        isCompleted
      }
      players {
        user {
          id
          username
          avatar
          xp
        }
        score
      }
    }
  }
`;

export const playMatchGQL = gql`
  mutation playMatch($playFriendMatchInput: PlayFriendMatchInput!) {
    playMatch(playFriendMatchInput: $playFriendMatchInput) {
      edgeNodeId
      matchId
      gameSessionId
      updatedWallets {
        coinType
        balance
      }
    }
  }
`;

export const createHouseMatchGQL = gql`
  mutation createHouseMatch($createHouseMatchInput: CreateHouseMatchInput!) {
    createHouseMatch(createHouseMatchInput: $createHouseMatchInput) {
      edgeNodeId
      matchId
      gameSessionId
      moment {
        id
        appId
        snapshotId
        title
        description
        type
        scoreLabel
        scoreZoneId
        time
        data
        timesPlayed
        showTimer
        momentType
        rankOrder
        status
        createdAt
        updatedAt
        app {
          type
          title
          id
          description
          timesPlayed
          rotationMode
          category
          data
          status
          hasBattle
          createdAt
          updatedAt
        }
        zoneId
        isCompleted
      }
      players {
        user {
          id
          username
          avatar
          xp
        }
        score
      }
    }
  }
`;

export const playHouseMatchGQL = gql`
  mutation playHouseMatch($playHouseMatchInput: PlayHouseMatchInput!) {
    playHouseMatch(playHouseMatchInput: $playHouseMatchInput) {
      edgeNodeId
      matchId
      gameSessionId
      updatedWallets {
        coinType
        balance
      }
    }
  }
`;
